var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"userTable",style:(_vm.domStyle)},[_c('Table',{attrs:{"border":"","columns":_vm.columns12,"data":_vm.data},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var row = ref.row;
return [_c('strong',[_vm._v(_vm._s(row.name))])]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Button',{attrs:{"type":"error","size":"small"},on:{"click":function($event){_vm.remove(index)}}},[_vm._v("强制退出")])]}}])}),_vm._v(" "),(_vm.isEnable)?_c('div',{style:(_vm.enableStyle)}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a037f11","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primitives/fvUserTable/fvUserTable.vue
// module id = null
// module chunks = 